import React, {Fragment, useEffect} from 'react';
import clsx from 'clsx';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {Hidden, IconButton, AppBar, Box, Tooltip, Button} from '@material-ui/core';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import MenuOpenRoundedIcon from '@material-ui/icons/MenuOpenRounded';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import projectLogo from '../../assets/images/bvik.png';
import {HeaderLogo} from './elements';
import {
    editCase,
    setActiveLink,
    setSidebarToggle,
    setSidebarToggleMobile
} from '../../vendors/actions/layout';
import {setSingleCase, findLawyer} from "../../vendors/actions/case";


interface OwnProps {

}

interface ConnectStateProps {
    User: {
        first_name: string;
        last_name: string;
        isAuthenticated?: boolean;
    }
}

interface ConnectDispatchProps {
    setSidebarToggle?: (data: any) => void;
    setSidebarToggleMobile?: (data: any) => void;
    setActiveLink?: (data: number) => void;
    setSingleCase?: (data: any) => void;
    editCase?: (data: any) => void;
    findLawyer?: (data: any) => void;
}

const Header = (props: any) => {

    const {setActiveLink} = props;
    const {
        headerShadow,
        headerFixed,
        sidebarToggleMobile,
        sidebarToggle,
        editCase,
    } = props.Layout;

    const {
        first_name,
        last_name
    } = props.User;

    const toggleSidebar = () => {
        props.setSidebarToggle(!sidebarToggle);
    };

    const toggleSidebarMobile = () => {
        props.setSidebarToggleMobile(!sidebarToggleMobile);
    };

    const navigate = (e: any, url: string) => {
        e.preventDefault();
        e.stopPropagation();
        props.setSingleCase({});
        props.findLawyer(undefined);
        setActiveLink('/find-lawyer');
        return props.history.push(url)
    };

    const cancelEdit = () => {
        props.editCase(false);
    };

    return (
        <Fragment>
            <AppBar
                color={'transparent'}
                className={clsx('app-header', {
                    'app-header-collapsed-sidebar': props.isCollapsedLayout
                })}
                position={headerFixed ? 'fixed' : 'absolute'}
                elevation={headerShadow ? 11 : 3}>
                {!props.isCollapsedLayout && <HeaderLogo/>}
                <Box className="app-header-toolbar">
                    {/**/}
                    <Hidden lgUp>
                        <Box className='align-items-center my-auto back-icon'>
                            {editCase && <ArrowBackIosOutlinedIcon onClick={cancelEdit}
                                                                   style={{
                                                                       color: 'white',
                                                                       width: '28px',
                                                                       height: '28px',
                                                                       cursor: 'pointer'
                                                                   }}/>}
                        </Box>
                        <Box
                            className='user-name text-white text-capitalize m-auto'>Welcome {first_name} {last_name}!</Box>
                    </Hidden>
                    <Hidden mdDown>
                        <Box className="d-flex align-items-center">
                            {!props.isCollapsedLayout && (
                                <Box
                                    className={clsx('btn-toggle-collapse', {
                                        'btn-toggle-collapse-closed': sidebarToggle
                                    })}>
                                    <IconButton
                                        color="inherit"
                                        onClick={toggleSidebar}
                                        size="medium"
                                        className="btn-inverse sidebar-icon">
                                        {sidebarToggle ? (
                                            <MenuRoundedIcon/>
                                        ) : (
                                            <MenuOpenRoundedIcon/>
                                        )}
                                    </IconButton>
                                </Box>
                            )}
                            <Box
                                className="user-name text-white text-capitalize">Welcome {first_name} {last_name}!</Box>
                        </Box>
                        <Box className="d-flex align-items-center">
                            <Button
                                href={'/find-lawyer'}
                                onClick={(e) => navigate(e, '/find-lawyer')}
                                size="small"
                                variant="contained"
                                className="link-btn text-transform-none">
                                Find a Lawyer
                            </Button>
                        </Box>
                    </Hidden>
                    <Hidden lgUp>
                        <Box className="d-flex align-items-center">
                            <Box className="toggle-sidebar-btn-mobile">
                                <IconButton
                                    className='text-white'
                                    onClick={toggleSidebarMobile}
                                    size="medium">
                                    {sidebarToggleMobile ? (
                                        <MenuOpenRoundedIcon/>
                                    ) : (
                                        <MenuRoundedIcon/>
                                    )}
                                </IconButton>
                            </Box>
                        </Box>
                    </Hidden>
                </Box>
            </AppBar>
        </Fragment>
    );
};


type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, Layout} = state;
    return {User, Layout}
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        setSidebarToggle: (data: any) => dispatch(setSidebarToggle(data)),
        setSidebarToggleMobile: (data: any) => dispatch(setSidebarToggleMobile(data)),
        setActiveLink: (data: number) => dispatch(setActiveLink(data)),
        setSingleCase: (data: any) => dispatch(setSingleCase(data)),
        findLawyer: (data: any) => dispatch(findLawyer(data)),
        editCase: (action: boolean) => dispatch(editCase(action)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);


